<div class="email-verification-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>Verify Your Email</h2>
        <button type="button" mat-icon-button aria-label="Close" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content>
        <div class="title-rule"></div>
        <p>We'll use your email associated with your account for notifications and important updates.</p>
        <p class="email"><strong>Email:</strong> <span>{{ data.email }}</span></p>
        <p>Please review the email address and confirm it is correct. If it isn't, select Update Email to go to your <strong>Account &gt; User Settings</strong> and make changes.</p>
        <p class="error-message" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
    </mat-dialog-content>

    <mat-dialog-actions align="start">
        <button mat-flat-button class="looks-good" type="button" (click)="confirmEmail()" [disabled]="isSaving" aria-label="Looks Good">
            Looks Good <mat-icon>chevron_right</mat-icon>
        </button>
        <button mat-stroked-button class="update-email" type="button" (click)="updateEmail()" [disabled]="isSaving" aria-label="Update Email">
            Update Email <mat-icon>chevron_right</mat-icon>
        </button>
    </mat-dialog-actions>
</div>